import React from 'react';
import { ResponsiveContainer, AreaChart, Area } from 'recharts';
import { COLORS, RADIUS, FONT } from '../shared/tokens';

/* KPI card — label, big value, optional sub-line, accent icon badge and an
   optional area sparkline (`spark` = [{ v: number }, ...]). All colours/radii
   come from tokens.js; nothing is hardcoded. */
export default function StatCard({ label, value, sub, accent = COLORS.primary, icon, spark }) {
    const gid = 'sg-' + String(label).replace(/\W+/g, '');
    const hasSpark = Array.isArray(spark) && spark.length > 1;
    return (
        <div style={{
            flex: '1 1 200px', minWidth: 0, boxSizing: 'border-box',
            background: COLORS.surface, border: `1px solid ${COLORS.border}`,
            borderRadius: RADIUS.card, padding: '16px 18px 14px', overflow: 'hidden',
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                <div style={{ minWidth: 0 }}>
                    <div style={{
                        fontFamily: FONT, fontSize: 11, fontWeight: 600, letterSpacing: '0.06em',
                        textTransform: 'uppercase', color: COLORS.textDim,
                        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    }}>
                        {label}
                    </div>
                    <div style={{
                        fontFamily: FONT, fontSize: 24, fontWeight: 800, color: COLORS.text,
                        lineHeight: 1.15, marginTop: 6,
                        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                    }}>
                        {value}
                    </div>
                    {sub && (
                        <div style={{ fontFamily: FONT, fontSize: 11, color: COLORS.textDim, marginTop: 4 }}>
                            {sub}
                        </div>
                    )}
                </div>
                <div style={{
                    width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                    background: `${accent}18`, border: `1px solid ${accent}33`, color: accent,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    {icon || <span style={{ width: 10, height: 10, borderRadius: '50%', background: accent }} />}
                </div>
            </div>
            {hasSpark && (
                <div style={{ height: 34, marginTop: 8, marginLeft: -4, marginRight: -4 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <AreaChart data={spark} margin={{ top: 2, right: 0, left: 0, bottom: 0 }}>
                            <defs>
                                <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stopColor={accent} stopOpacity={0.35} />
                                    <stop offset="100%" stopColor={accent} stopOpacity={0} />
                                </linearGradient>
                            </defs>
                            <Area type="monotone" dataKey="v" stroke={accent} strokeWidth={2} fill={`url(#${gid})`} dot={false} isAnimationActive={false} />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    );
}
